<template>
    <div>
        <van-nav-bar
        title="任务教程"
        left-text="返回"

        left-arrow
        @click-left="onClickLeft"
        />
    </div>
</template>
<script>
import { useRouter } from 'vue-router';
  
export default {
    
    setup(){
        const router=useRouter();
        const onClickLeft = () => {
              if (window.history.length <= 1) {
                  router.push({ path: "/process" });
                  return false;
              } else {
                  router.go(-1);
              }
          }
        return{
            onClickLeft
        }
    }
}
</script>
<style scoped>
    .card{
        margin-top:5px;
        margin-bottom: 5px;
       /* margin:5px; */
       /* border-radius:5px; */
       background: #fff;
    }
   </style>